import { MultiResponseType } from '../../models/multiResponseType';
import { 
    IConfirmedReport,
    // IReportConfirm as ReportConfirm, 
    IIsCoordinatorConfirmedReport as IsCoordinatorConfirmedReport
} from '../../models/reportConfirm';
import { SingleResponseType } from '../../models/singleResponseType';
// import { MultiRecordResponse } from '../actionCreators/actionResultTypes';

export enum ActionType {
    FETCH_COORDINATORCONFIRM = 'FETCH_COORDINATORCONFIRM',
    FETCH_COORDINATORCONFIRM_SUCCESS = 'FETCH_COORDINATORCONFIRM_SUCCESS',
    FETCH_COORDINATORCONFIRM_FAIL = 'FETCH_COORDINATORCONFIRM_FAIL',
    FETCH_CONFIRMREPORTS = 'FETCH_CONFIRMREPORTS',
    FETCH_CONFIRMREPORTS_SUCCESS = 'FETCH_CONFIRMREPORTS_SUCCESS',
    FETCH_CONFIRMREPORTS_FAIL = 'FETCH_CONFIRMREPORTS_FAIL',
    EDIT_COORDINATORCONFIRM = 'EDIT_COORDINATORCONFIRM',
    EDIT_COORDINATORCONFIRM_SUCCESS = 'EDIT_COORDINATORCONFIRM_SUCCESS',
    EDIT_COORDINATORCONFIRM_FAIL = 'EDIT_COORDINATORCONFIRM_FAIL',
    EDIT_CONTRACTDATES_SUCCESS = 'EDIT_CONTRACTDATES_SUCCESS',
    EDIT_PROJECTMANAGERCONFIRM_SUCCESS = 'EDIT_PROJECTMANAGERCONFIRM_SUCCESS',
}

export interface IFetchIsConfirmedReport {
    type: ActionType.FETCH_COORDINATORCONFIRM;
}
export interface IFetchIsConfirmedReportSuccess {
    type: ActionType.FETCH_COORDINATORCONFIRM_SUCCESS;
    payload: SingleResponseType<IsCoordinatorConfirmedReport>
}
export interface IFetchIsConfirmedReportFail {
    type: ActionType.FETCH_COORDINATORCONFIRM_FAIL;
    payload: string | null;
}
export interface IFetchConfirmedReports {
    type: ActionType.FETCH_CONFIRMREPORTS;
}
export interface IFetchConfirmedReportsSuccess {
    type: ActionType.FETCH_CONFIRMREPORTS_SUCCESS;
    payload: MultiResponseType<IConfirmedReport>
}
export interface IFetchConfirmedReportsFail {
    type: ActionType.FETCH_CONFIRMREPORTS_FAIL;
    payload: string | null;
}
export interface IEditIsConfirmedReport {
    type: ActionType.EDIT_COORDINATORCONFIRM;
}
export interface IEditIsConfirmedReportSuccess {
    type: ActionType.EDIT_COORDINATORCONFIRM_SUCCESS;
    payload: SingleResponseType<IsCoordinatorConfirmedReport>
}
export interface IEditIsConfirmedReportFail {
    type: ActionType.EDIT_COORDINATORCONFIRM_FAIL;
    payload: string | null;
}
export interface IProjectManagerConfirmSuccess {
    type: ActionType.EDIT_PROJECTMANAGERCONFIRM_SUCCESS;
}

export type Action =
    | IFetchIsConfirmedReport
    | IFetchIsConfirmedReportSuccess
    | IFetchIsConfirmedReportFail
    | IFetchConfirmedReports
    | IFetchConfirmedReportsSuccess
    | IFetchConfirmedReportsFail
    | IProjectManagerConfirmSuccess
    | IEditIsConfirmedReport
    | IEditIsConfirmedReportSuccess
    | IEditIsConfirmedReportFail
